import { getUseResource } from '../resource';
import { scheduledResources } from '../builders/scheduledResources';
import { IPendingCustomerProduct } from '../../models/PendingCustomerProduct';
import { IPaginatedContent } from '../../models/PaginatedContent';
import { ICronJob } from '../../models/CronJob';
import { IServerSidePaginatedFetcherParams } from '../../contexts/Fetcher';

export const apiScheduled = {
  useGetOrganizationTasks: getUseResource(
    scheduledResources.getOrganizationTasks,
    (body): IPendingCustomerProduct[] => body
  ),
  useGetOrganizationProduct: getUseResource(
    scheduledResources.getOrganizationProductTasks,
    (body): IPendingCustomerProduct[] => body
  ),
  useCancelJob: getUseResource(scheduledResources.cancelJob, (body): void => body),
  useGetAllJobs: getUseResource(
    scheduledResources.getAllJobs,
    (body): { cronJobs: IPaginatedContent<ICronJob> } => body,
    (params, { filter, sort, ...pagination }: IServerSidePaginatedFetcherParams) => ({
      ...filter,
      ...sort,
      ...pagination,
    })
  ),
  useGetJob: getUseResource(scheduledResources.getJob, (body): ICronJob => body),
};
